import { render } from "./RegisterFish.vue?vue&type=template&id=434741a6"
import script from "./RegisterFish.vue?vue&type=script&lang=js"
export * from "./RegisterFish.vue?vue&type=script&lang=js"

import exportComponent from "/home/christian/Trabalho/fish_coletor/Coletor-APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__